import PaymentsPanel from './PaymentsPanel';

export default PaymentsPanel;
